import { api } from "@/lib/axios";

export default function deleteNote(noteId: string) {
  return api.delete(`notes/${noteId}`);
}
